document.querySelectorAll('.date-picker-single').forEach((component) => {
  const pickerInput = component.querySelector('.date-picker-single__picker');
  const dayInput = component.querySelector('.date-picker-single__day input');
  const monthInput = component.querySelector('.date-picker-single__month input');
  const yearInput = component.querySelector('.date-picker-single__year input');
  const locale = localData?.calendar?.locale || flatpickr.l10ns.sl;

  const fp = flatpickr(pickerInput, {
    dateFormat: 'd.M.Y',
    locale,
    positionElement: dayInput,
    disableMobile: true,

    onChange(selectedDates) {
      if (!selectedDates.length) return;

      const date = selectedDates[0];

      dayInput.value = String(date.getDate()).padStart(2, '0');
      monthInput.value = locale.months.longhand[date.getMonth()];
      yearInput.value = date.getFullYear();
    },
  });

  [dayInput, monthInput, yearInput].forEach((input) => {
    input.addEventListener('click', () => {
      fp.set('positionElement', input);
      fp.open();
    });

    input.addEventListener('focus', () => {
      fp.set('positionElement', input);
      fp.open();
    });
  });
});
